function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "tools-com",
  transform: "translate(0 0.007)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_11616",
  "data-name": "Path 11616",
  d: "M0,2.25,2.25,0,9.182,4.95a2.25,2.25,0,0,1,.943,1.834v.158a2.25,2.25,0,0,0,.659,1.593l12.841,12.84,2.057-.686a2.25,2.25,0,0,1,2.3.544l7.551,7.551a2.25,2.25,0,0,1,0,3.181l-3.569,3.569a2.25,2.25,0,0,1-3.181,0l-7.551-7.551a2.25,2.25,0,0,1-.544-2.3l.685-2.056L8.534,10.784a2.25,2.25,0,0,0-1.591-.659h-.16a2.25,2.25,0,0,1-1.831-.943Zm25.546,21.7a1.126,1.126,0,0,0-1.593,1.593L30.7,32.3A1.126,1.126,0,0,0,32.3,30.7l-6.75-6.75Z",
  fill: "#fff",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_11617",
  "data-name": "Path 11617",
  d: "M35.77,5a6.757,6.757,0,0,1-8.278,8.267L13.226,27.338a6.75,6.75,0,1,1-4.561-4.561L22.732,8.51A6.75,6.75,0,0,1,31,.225L26.182,5.044,27,9l3.953.819L35.77,5ZM5.688,25.295l1.064-.545,1.06.544L9,25.352l.646,1,1,.646.058,1.19.543,1.061-.544,1.06-.058,1.19-1,.646-.646,1-1.19.058L6.75,33.75l-1.06-.544L4.5,33.147l-.646-1-1-.646-.058-1.19L2.25,29.25l.544-1.06L2.852,27l1-.646.646-1,1.19-.058Z",
  fill: "#fff",
  fillRule: "evenodd"
}));

var SvgToolsCom = function SvgToolsCom(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36.193,
    height: 36.2,
    viewBox: "0 0 36.193 36.2",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgToolsCom, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/tools-com.8f7729aa.svg";
export { ForwardRef as ReactComponent };